import React from 'react'
import { ROS_GROUPS } from '../../Components/utils';

const ROSFields = (props) => {
    // ReviewOfSystem
    let { rosData, setSubjectiveData, setSaveROSData } = { ...props };
    console.log("rosData", rosData)
    
    const handleROS = (e) => {
        let { name } = e.target;
        setSubjectiveData(prev => {
            console.log("setSubjectiveData", prev)
           return ({
                ...prev,
                'ReviewOfSystem': {
                    ...prev?.ReviewOfSystem,
                    [name]: prev?.ReviewOfSystem?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveROSData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }
  return (
        <div className="observation-content d-flex flex-column gap-12 HPI-scroll ROS-scroll">
            {ROS_GROUPS.map((group, groupIndex) => {
            // Get only items that exist in your rosData
            const groupItems = group.items || [];

            return (
                <div key={group.title + groupIndex} className="d-flex flex-column gap-1">
                    <p className="heading font-m">{group.title}</p>

                    <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">
                        {groupItems.map((item, index) => (
                        <label
                            key={item.key}
                            className="d-flex align-items-center gap-6 user-select-none"
                        >
                            <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name={item.key}
                                checked={rosData?.[item.key] === "true"}
                                onChange={handleROS}
                            />
                            </div>
                            <p className="text lh-12">{item.label}</p>
                        </label>
                        ))}
                    </div>
                </div>
            );
            })}

        {/* --------------------- Constitution --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Constitution</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_ActivityChange"
                    checked={rosData?.Con_ActivityChange === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Activity Change</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_AppetiteChange"
                    checked={rosData?.Con_AppetiteChange === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Appetite Change</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_Chills"
                    checked={rosData?.Con_Chills === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Chills</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_Diaphoresis"
                    checked={rosData?.Con_Diaphoresis === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Diaphoresis</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_Fatigue"
                    checked={rosData?.Con_Fatigue === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Fatigue</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_Fever"
                    checked={rosData?.Con_Fever === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Fever</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Con_UnexpectedWeightChange"
                    checked={rosData?.Con_UnexpectedWeightChange === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Unexpected weight change</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Head --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Head</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_FacialSwelling"
                    checked={rosData?.Head_FacialSwelling === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Facial swelling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_NeckPain"
                    checked={rosData?.Head_NeckPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Neck pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_NeckStiffness"
                    checked={rosData?.Head_NeckStiffness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Neck stiffness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_EarDischarge"
                    checked={rosData?.Head_EarDischarge === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Ear discharge</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_HearingAid"
                    checked={rosData?.Head_HearingAid === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Hearing aid</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_ChangesInHearing"
                    checked={rosData?.Head_ChangesInHearing === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Changes in hearing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_EarPain"
                    checked={rosData?.Head_EarPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Ear pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_Tinnitus"
                    checked={rosData?.Head_Tinnitus === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Tinnitus</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_Nosebleeds"
                    checked={rosData?.Head_Nosebleeds === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Nosebleeds</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_Congestion"
                    checked={rosData?.Head_Congestion === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Congestion</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_Rhinorrhea"
                    checked={rosData?.Head_Rhinorrhea === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Rhinorrhea</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_PostnasalDrip"
                    checked={rosData?.Head_PostnasalDrip === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Postnasal drip</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_Sneezing"
                    checked={rosData?.Head_Sneezing === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Sneezing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_SinusPressure"
                    checked={rosData?.Head_SinusPressure === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Sinus pressure</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_DentalProblem"
                    checked={rosData?.Head_DentalProblem === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Dental problem</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_Drooling"
                    checked={rosData?.Head_Drooling === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Drooling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_MouthSores"
                    checked={rosData?.Head_MouthSores === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Mouth sores</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_SoreThroat"
                    checked={rosData?.Head_SoreThroat === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Sore throat</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_TroubleSwallowing"
                    checked={rosData?.Head_TroubleSwallowing === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Trouble swallowing</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Head_VoiceChange"
                    checked={rosData?.Head_VoiceChange === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Voice change</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Eyes --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Eyes</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_ContactLenses"
                    checked={rosData?.Eye_ContactLenses === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Contact lenses</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_EyeDischarge"
                    checked={rosData?.Eye_EyeDischarge === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Eye discharge</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_EyeItching"
                    checked={rosData?.Eye_EyeItching === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Eye itching</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_EyePain"
                    checked={rosData?.Eye_EyePain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Eye pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_EyeRedness"
                    checked={rosData?.Eye_EyeRedness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Eye redness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_Glasses"
                    checked={rosData?.Eye_Glasses === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Glasses</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_Photophobia"
                    checked={rosData?.Eye_Photophobia === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Photophobia</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Eye_UnexpectedVisionChange"
                    checked={rosData?.Eye_UnexpectedVisionChange === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Unexpected vision change</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Respiratory --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Respiratory</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Apnea"
                    checked={rosData?.Resp_Apnea === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Apnea</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_ChestTightness"
                    checked={rosData?.Resp_ChestTightness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Chest tightness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Choking"
                    checked={rosData?.Resp_Choking === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Choking</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Cough"
                    checked={rosData?.Resp_Cough === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Cough</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_ShortnessOfBreath"
                    checked={rosData?.Resp_ShortnessOfBreath === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Shortness of breath</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Stridor"
                    checked={rosData?.Resp_Stridor === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Strider</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Resp_Wheezing"
                    checked={rosData?.Resp_Wheezing === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Wheezing</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Cardiovascular --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Cardiovascular</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Card_ChestPain"
                    checked={rosData?.Card_ChestPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Chest pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Card_LegSwelling"
                    checked={rosData?.Card_LegSwelling === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Leg swelling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Card_Palpitations"
                    checked={rosData?.Card_Palpitations === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Palpitations</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Card_AllDay"
                    checked={rosData?.Card_AllDay === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">All day</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- GI --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">GI</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_AbdDistention"
                    checked={rosData?.Gi_AbdDistention === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Abd distention</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_AbdominalPain"
                    checked={rosData?.Gi_AbdominalPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Abdominal Pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_AnalBleeding"
                    checked={rosData?.Gi_AnalBleeding === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Anal bleeding</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_BloodInStool"
                    checked={rosData?.Gi_BloodInStool === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Blood in stool</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_Constipation"
                    checked={rosData?.Gi_Constipation === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Constipation</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_Diarrhea"
                    checked={rosData?.Gi_Diarrhea === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Diarrhea</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_Heartburn"
                    checked={rosData?.Gi_Heartburn === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Heartburn</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_Nausea"
                    checked={rosData?.Gi_Nausea === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Nausea</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_RectalPain"
                    checked={rosData?.Gi_RectalPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Rectal pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gi_Vomiting"
                    checked={rosData?.Gi_Vomiting === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Vomiting</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Endocrine --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Endocrine</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Endo_ColdIntolerance"
                    checked={rosData?.Endo_ColdIntolerance === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Cold intolerance</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Endo_HeatIntolerance"
                    checked={rosData?.Endo_HeatIntolerance === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Heat intolerance</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Endo_HotFlashes"
                    checked={rosData?.Endo_HotFlashes === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Hot flashes</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Endo_Polydipsia"
                    checked={rosData?.Endo_Polydipsia === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Polydipsia</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Endo_Polyphagia"
                    checked={rosData?.Endo_Polyphagia === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Polyphagia</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Endo_Polyuria"
                    checked={rosData?.Endo_Polyuria === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Polyuria</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- GU --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">GU</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_ProblemWithUrination"
                    checked={rosData?.Gu_ProblemWithUrination === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Problem with urination</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_Dysuria"
                    checked={rosData?.Gu_Dysuria === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Dysuria</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_ErectileDysfunction"
                    checked={rosData?.Gu_ErectileDysfunction === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Erectile dysfunction</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_FlankPain"
                    checked={rosData?.Gu_FlankPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Flank pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_Frequency"
                    checked={rosData?.Gu_Frequency === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Frequency</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_GenitalSore"
                    checked={rosData?.Gu_GenitalSore === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Genital sore</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_BloodInUrine"
                    checked={rosData?.Gu_BloodInUrine === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Blood in urine</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_Incontinence"
                    checked={rosData?.Gu_Incontinence === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Incontinence(bladder)</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_Nocturia"
                    checked={rosData?.Gu_Nocturia === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Nocturia</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_PenileDischarge"
                    checked={rosData?.Gu_PenileDischarge === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Penile discharge</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_PenilePain"
                    checked={rosData?.Gu_PenilePain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Penile pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_PenileSwelling"
                    checked={rosData?.Gu_PenileSwelling === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Penile swelling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_ScrotalSwelling"
                    checked={rosData?.Gu_ScrotalSwelling === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Scrotal swelling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_TesticularPain"
                    checked={rosData?.Gu_TesticularPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Testicular pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_Urgency"
                    checked={rosData?.Gu_Urgency === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Urgency</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Gu_UrineDecreased"
                    checked={rosData?.Gu_UrineDecreased === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Urine decreased</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Musc --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Musc</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Musc_JointPain"
                    checked={rosData?.Musc_JointPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Joint pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Musc_BackPain"
                    checked={rosData?.Musc_BackPain === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Back pain</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Musc_GaitProblem"
                    checked={rosData?.Musc_GaitProblem === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Gait problem</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Musc_JointSwelling"
                    checked={rosData?.Musc_JointSwelling === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Joint swelling</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Musc_Myalgias"
                    checked={rosData?.Musc_Myalgias === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Myalgias</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Skin --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Skin</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Skin_ColorChange"
                    checked={rosData?.Skin_ColorChange === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Color change</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Skin_Pallor"
                    checked={rosData?.Skin_Pallor === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Pallor</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Skin_PersistentRash"
                    checked={rosData?.Skin_PersistentRash === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Persistent rash</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Skin_Wound"
                    checked={rosData?.Skin_Wound === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Wound</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Allergy/Immuno --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Allerg/Immuno</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Allerg_EnvironmentalAllergies"
                    checked={rosData?.Allerg_EnvironmentalAllergies === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Env allergies</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Allerg_FoodAllergies"
                    checked={rosData?.Allerg_FoodAllergies === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Food allergies</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Allerg_Immunocompromised"
                    checked={rosData?.Allerg_Immunocompromised === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Immunocompromised</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Allerg_Wound"
                    checked={rosData?.Allerg_Wound === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Wound</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Neurological --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Neurological</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_MemoryChanges"
                    checked={rosData?.Neuro_MemoryChanges === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Changes in memory</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_Dizziness"
                    checked={rosData?.Neuro_Dizziness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Dizziness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_FacialAsymmetry"
                    checked={rosData?.Neuro_FacialAsymmetry === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Facial asymmetry</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_Headaches"
                    checked={rosData?.Neuro_Headaches === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Headaches</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_LightHeadedness"
                    checked={rosData?.Neuro_LightHeadedness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Light headedness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_Numbness"
                    checked={rosData?.Neuro_Numbness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Numbness</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_Seizures"
                    checked={rosData?.Neuro_Seizures === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Seizures</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_SpeechDifficulty"
                    checked={rosData?.Neuro_SpeechDifficulty === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Speech difficulty</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_Syncope"
                    checked={rosData?.Neuro_Syncope === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Syncope</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Neuro_Weakness"
                    checked={rosData?.Neuro_Weakness === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Weakness</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Hematologic --------------------- */}
        {/* <div className="d-flex flex-column gap-1">
            <p className="heading font-m">Hematologic</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Hem_Adenopathy"
                    checked={rosData?.Hem_Adenopathy === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Adenopathy</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Hem_BruisesEasily"
                    checked={rosData?.Hem_BruisesEasily === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Bruises/blds easily</p>
            </label>


            </div>
        </div> */}

        {/* --------------------- Psychiatric --------------------- */}
        {/* <div className="d-flex flex-column gap-1 pb-3">
            <p className="heading font-m">Psychiatric</p>
            <div className="d-flex align-items-center gap-12 flex-wrap row-gap-10">

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_Agitation"
                    checked={rosData?.Psych_Agitation === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Agitation</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_BehaviorProblem"
                    checked={rosData?.Psych_BehaviorProblem === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Behavior problem</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_Confusion"
                    checked={rosData?.Psych_Confusion === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Confusion</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_DecreasedConcentration"
                    checked={rosData?.Psych_DecreasedConcentration === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Decr concentration</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_DysphoricMood"
                    checked={rosData?.Psych_DysphoricMood === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Dysphoric mood</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_Hallucinations"
                    checked={rosData?.Psych_Hallucinations === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Hallucinations</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_Hyperactive"
                    checked={rosData?.Psych_Hyperactive === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Hyperactive</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_NervousAnxious"
                    checked={rosData?.Psych_NervousAnxious === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Nervous/anxious</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_SelfInjury"
                    checked={rosData?.Psych_SelfInjury === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Self injury</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_SleepDisturbance"
                    checked={rosData?.Psych_SleepDisturbance === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Sleep disturbance</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0" 
                    name="Psych_SuicidalIdeas"
                    checked={rosData?.Psych_SuicidalIdeas === "true"}
                    onChange={handleROS}/>
                </div>
                <p className="text lh-12">Suicidal ideas</p>
            </label>


            </div>
        </div> */}

        </div>
  )
}

export default ROSFields